import { render, staticRenderFns } from "./updataAndview-physicalmodel.vue?vue&type=template&id=3ea5057f"
import script from "./updataAndview-physicalmodel.vue?vue&type=script&lang=js"
export * from "./updataAndview-physicalmodel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ea5057f')) {
      api.createRecord('3ea5057f', component.options)
    } else {
      api.reload('3ea5057f', component.options)
    }
    module.hot.accept("./updataAndview-physicalmodel.vue?vue&type=template&id=3ea5057f", function () {
      api.rerender('3ea5057f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/product/physicalmodel/updataAndview-physicalmodel.vue"
export default component.exports